import React from 'react';
import { Box, Button, Theme, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { RuleImportExportButtons } from './import-export/RuleImportExportButtons';
import { useCurrencies } from '../../currency/CurrenciesContext';
import { useFeatures } from '../../features/FeaturesContext';

const useStyles = makeStyles<Theme>(({ spacing }) => ({
  root: {
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    zIndex: 2,
  },
}));

interface Props {
  onAdd: () => void;
  ruleType: 'BURNING_RULE' | 'EARNING_RULE';
}

export function RulesFilters({ onAdd, ruleType }: Props): React.ReactElement {
  const classes = useStyles();
  const { t } = useTranslation();
  const { features } = useFeatures();
  const { currencies } = useCurrencies();
  const hasActiveCurrencies = !!currencies.find(currency => !currency.deletedAt);
  const { write: ruleWrite } = features[ruleType];
  const tooltipText = !ruleWrite
    ? t('shared.action.permission.required')
    : !hasActiveCurrencies
    ? t('rule.add.no-active-currency')
    : '';

  return (
    <div className={classes.root}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Tooltip title={tooltipText} placement="left">
          <div>
            <Button
              startIcon={<FontAwesomeIcon icon={faPlus} />}
              variant="contained"
              color="primary"
              onClick={onAdd}
              disabled={!ruleWrite || !hasActiveCurrencies}
            >
              {t('rules.actions.add')}
            </Button>
          </div>
        </Tooltip>
        <RuleImportExportButtons ruleType={ruleType} />
      </Box>
    </div>
  );
}
